import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'
import { notifyObjectKeptWithinPasteboard } from '@/components/app/editor/toasts'

/**
 * Pasteboard-boundary guard's revert, shared by single and batch commits: restores each shape's
 * pre-commit values (bypassing edit guards, since this undoes the user's own gesture), pulses the
 * selection chrome and shows the "kept within pasteboard" notice. Runs before any persistence or
 * history, so the out-of-bounds commit leaves no trace.
 */
export function revertCommitOutsidePasteboard(
  mgr: ShapeManagerRef | null | undefined,
  reverts: readonly { shapeId: string; before: Partial<ShapeData> }[]
): void {
  for (const { shapeId, before } of reverts) {
    mgr?.updateShape(shapeId, before, { bypassEditGuards: true })
  }

  mgr?.triggerSelectionGeometryBlockedPulse()
  notifyObjectKeptWithinPasteboard()
}
